import { useEffect, useReducer } from 'react';
import { ensureImmutability } from './ensureImmutability';
export function useGetState(store) {
    var _a = useReducer(function () {
        var v = store.getState();
        return ensureImmutability(v);
    }, store.getState()), value = _a[0], dispatch = _a[1];
    useEffect(function () {
        var unsubscribe = store.subscribeAll(dispatch);
        return function () {
            unsubscribe();
        };
    }, [store.subscribeAll]);
    return value;
}
//# sourceMappingURL=useGetState.js.map